module.exports = __webpack_public_path__ + "img/moulding.400262ac.svg";